import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import AuthRoute from "./components/AuthRoute";
import Home from "./pages/home"; 

const AppShell = lazy(() => import("./AppShell")); // everything else: theme, auth pages, user, mentor

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          {/* Fast path: no theme provider, no MUI, no Suspense wait */}
          <Route path="/" element={<AuthRoute><Home /></AuthRoute>} />

          {/* Everything else loads the themed, MUI-based app on demand */}
          <Route
            path="/*"
            element={
              <Suspense fallback={<div className="app-loading" />}>
                <AppShell />
              </Suspense>
            }
          />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;